import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import i18n from './mixins/i18n';
import router from './router';

window.axios = axios.create({
  baseURL: 'https://api-v2.forsabarter.com/api',
  headers: { common: { 'accept-language': localStorage.getItem('lang') || 'ar' } }
});

Vue.mixin(i18n)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify, // This enables all Vuetify components
  render: h => h(App)
}).$mount('#app')